import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const ADD_INTERACTION_MUTATION = gql`
  mutation AddInteractionMutation($interaction: TBL_INTERACTIONS_Input) {
    addInteraction(interaction: $interaction)
  }
`;

const UPDATE_INTERACTION_MUTATION = gql`
  mutation UpdateInteractionMutation($interaction: TBL_INTERACTIONS_Input, $interactionid: ID!) {
    updateInteraction(interaction: $interaction, INTERACTIONID: $interactionid)
  }
`;

const DELETE_INTERACTION_MUTATION = gql`
  mutation DeleteInteractionMutation($interactionid: ID!) {
    deleteInteraction(INTERACTIONID: $interactionid)
  }
`;

export default function useInteractionMutate() {
  const { mutate: addMutate } = useMutation(ADD_INTERACTION_MUTATION);
  const { mutate: updateMutate } = useMutation(UPDATE_INTERACTION_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_INTERACTION_MUTATION);

  async function addInteraction(interaction) {
    try {
      const { data } = await addMutate({ interaction });
      return data;
    } catch (error) {
      console.error('Error adding interaction:', error);
      addAlert('Error adding interaction', 'high', 4);
      return null;
    }
  }

  async function updateInteraction(interactionid, interaction) {
    try {
      const { data } = await updateMutate({ interaction, interactionid });
      return data;
    } catch (error) {
      console.error('Error updating interaction:', error);
      addAlert('Error updating interaction', 'high', 4);
      return null;
    }
  }

  async function deleteInteraction(interactionid) {
    try {
      const { data } = await deleteMutate({ interactionid });
      return data;
    } catch (error) {
      console.error('Error deleting interaction:', error);
      addAlert('Error deleting interaction', 'high', 4);
      return null;
    }
  }

  return {
    addInteraction,
    updateInteraction,
    deleteInteraction,
  };
}
